export default __webpack_public_path__ + "static/media/select_hotel.d653e497.png";